import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import axios from "axios";
const BASE_URL = process.env.REACT_APP_BASE_URL;

const getEmptyQuote = () => {
  return {
    quote: "",
  };
};

function QuoteForm() {
  const [quote, setQuote] = useState(getEmptyQuote());
  const navigate = useNavigate();

  const handleChange = (e) => {
    setQuote({
      ...quote,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("UnAuthorized");
      }
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const formData = new FormData();
      for (const key in quote) {
        formData.append(key, quote[key]);
      }
      const response = await axios.post(`${BASE_URL}/quotes`, formData, config);
      if (response.data.success === true) {
        alert("Quote added successfully");
        navigate("/admin/quotes");
      } else {
        throw new Error(response.data.message);
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  const handleReset = () => {
    setQuote(getEmptyQuote());
  };

  return (
    <div className="py-3 container is-fluid">
      <form encType="multipart/form-data">
        <div className="columns is-centered">
          <div className="column is-two-thirds">
            <div className="field">
              <label className="label">Quote</label>
              <div className="control">
                <input
                  autoFocus
                  name="quote"
                  className="input"
                  type="text"
                  value={quote.quote}
                  placeholder='"Quote" -- Author'
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="field is-grouped">
              <div className="control">
                <button
                  type="submit"
                  className="button is-link is-success"
                  onClick={handleSubmit}
                >
                  Submit
                </button>
              </div>
              <div className="control">
                <button
                  type="reset"
                  className="button is-link is-light is-danger"
                  onClick={handleReset}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default QuoteForm;
